import { InjectionToken } from '@angular/core';

import type { Observable } from 'rxjs';

import type { PaymentInterval } from '@core/billing-types';

export enum ProductOrderStepUrl {
  ProductPicker = 'select-product',
  Downgrade = 'downgrade',
  OrderBilling = 'billing',
  OrderPayment = 'payment',
  Migration = 'migration',
}

export const ProductOrderDefaultStep = ProductOrderStepUrl.ProductPicker;

export type ProductOrderStepBreadcrumb =
  | ProductOrderStepUrl.ProductPicker
  | ProductOrderStepUrl.OrderBilling
  | ProductOrderStepUrl.OrderPayment;

export type ProductOrderParams = {
  productId: number;
  interval: PaymentInterval;
  slots?: number;
  quantity?: number;
};

export const ProductOrderParamsIT = new InjectionToken<Observable<ProductOrderParams>>(
  'ProductOrderParams',
);
